import { gql, TypedDocumentNode } from "@apollo/client";

import { Query, Mutation, MutationApiKeyEnableNonRootManagersArgs } from "types/generated";

type GetApiKeysManagedByNonRootAdminsData = Pick<Query, "apiKeysManagedByNonRootAdmins">;

export const GET_API_KEYS_MANAGED_BY_NON_ROOT_ADMINS: TypedDocumentNode<GetApiKeysManagedByNonRootAdminsData> = gql`
  query GetApiKeysManagedByNonRootAdmins {
    apiKeysManagedByNonRootAdmins
  }
`;

type SetApiKeysManagedByNonRootAdminsData = Pick<Mutation, "apiKeyEnableNonRootManagers">;

export const SET_API_KEYS_MANAGED_BY_NON_ROOT_ADMINS: TypedDocumentNode<
  SetApiKeysManagedByNonRootAdminsData,
  MutationApiKeyEnableNonRootManagersArgs
> = gql`
  mutation SetApiKeysManagedByNonRootAdmins($enable: Boolean!) {
    apiKeyEnableNonRootManagers(enable: $enable)
  }
`;
